import { render, staticRenderFns } from "./set-ok.vue?vue&type=template&id=39fc9c90&scoped=true"
import script from "./set-ok.vue?vue&type=script&lang=js"
export * from "./set-ok.vue?vue&type=script&lang=js"
import style0 from "./set-ok.vue?vue&type=style&index=0&id=39fc9c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc9c90",
  null
  
)

export default component.exports